import {useRouteQuery} from '@github-ui/react-core/future/use-route-query'
import {useRouteQueryKey} from '@github-ui/react-core/future/use-route-query-key'
import {useOverviewRoute} from './use-overview-route'

export function useOverviewRouteData() {
  const overviewRoute = useOverviewRoute()
  return useRouteQuery(overviewRoute, 'mainQuery')
}

export function useOverviewRouteQueryKey() {
  const overviewRoute = useOverviewRoute()
  return useRouteQueryKey(overviewRoute, 'mainQuery')
}
